import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import folderIdFactory from 'owa-service/lib/factory/folderId';
/* tslint:disable:restrict-import-path */
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
/* tslint:enable:restrict-import-path */
import getCalendarViewOperation from 'owa-service/lib/operation/getCalendarViewOperation';
import getCalendarViewRequest from 'owa-service/lib/factory/getCalendarViewRequest';
import targetFolderId from 'owa-service/lib/factory/targetFolderId';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export default function getCalendarViewService(
    rangeStart: Date,
    rangeEnd: Date
): Promise<CalendarItem[]> {
    // Example:
    // RangeStart: "2016-12-02T00:00:00.001",
    // RangeEnd: "2016-12-04T00:00:00.000"
    return getCalendarViewOperation({
        Header: getJsonRequestHeader(),
        Body: getCalendarViewRequest({
            CalendarId: targetFolderId({
                BaseFolderId: folderIdFactory({
                    Id: folderNameToId('calendar'),
                }),
            }),
            RangeStart: rangeStart.toISOString(),
            RangeEnd: rangeEnd.toISOString(),
        }),
    }).then(response => {
        return response.Body.Items;
    });
}
